// @flow

import Cookies from 'js-cookie'
import path from 'path'

declare var globalThis: { document?: Document }
const POLICY_COOKIE_NAME = 'cookie-policy-warning'

export const script = (publicPath: string, cookieWarningPath?: string) =>
  cookieWarningPath
    ? `<script src="${
        new URL(
          path.join(new URL(publicPath).pathname, cookieWarningPath),
          publicPath
        ).href
      }"></script>`
    : ''

const main = () => {
  if (!cookieExists()) {
    showWarning()
  }
}

const showWarning = () => {
  if (!globalThis.document) {
    return
  }

  const { document } = globalThis

  require('./styles.css')
  const container = document.createElement('div')

  container.innerHTML = `
    <p>
      We use cookies to ensure you get the best experience on our site.
      <a href="/legal/"><span class="toggl-cw-strong">More details.</span></a>
    </p>
    <button class="toggl-cw-button" type="button">Got it</button>
  `
  container.classList.add('toggl-cw-body')

  document.body?.appendChild(container)
  document
    .querySelector('.toggl-cw-button')
    ?.addEventListener('click', onClickButton)
}

const cookieExists = () => !!Cookies.get(POLICY_COOKIE_NAME)

const setCookie = () =>
  Cookies.set(POLICY_COOKIE_NAME, 'Read', { expires: 730, path: '/' })

const hideWarning = () =>
  globalThis.document?.querySelector('.toggl-cw-body')?.classList.add('hidden')

const onClickButton = () => {
  setCookie()
  hideWarning()
}

if ('window' in globalThis) {
  main()
}
